import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { formatDateTime, formatDate } from "../../../utils/dateUtils";
import { userTypeOptions } from '../../../utils/constants';


const TasksDetailPrint = () => {
    const { date } = useParams();
    const [tasks, setTasks] = useState([]);
      const [isLoading, setIsLoading] = useState(false);
    

    useEffect(() => {
        setIsLoading(true)
        axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/assistant-manager/get-tasks-detail-by-date/${date}`, {
            withCredentials: true,
        }).then(res => {
                    setIsLoading(false)

            if (res.data.status) setTasks(res.data.tasks);
        });
    }, [date]);

    const handleStatusChange = (taskId, status) => {
        axios.post(`${process.env.REACT_APP_WEB_SERVICES_URL}/assistant-manager/update-task-status`, {
            task_id: taskId,
            status
        }, {
            withCredentials: true,
        }).then(res => {
            if (res.data.status) {
                setTasks(prev => prev.map(t => t.id === taskId ? { ...t, status } : t));
            }
        });
    };

    
    return (
        <div className="container-fluid px-4 py-5">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3>Tasks for {formatDate(date)}</h3>
            </div>

            <div className="card shadow">
                <div className="card-body p-4">
                    <div className="table-responsive">
                        <table className="table table-bordered table-hover shadow-sm">
                            <thead className="table-success">
                                <tr>
                                    <th>Sr. #</th>
                                    <th>User Type</th>
                                    <th>User</th>
                                    <th>Date & Time</th>
                                    <th>Task</th>
                                    <th>Details</th>
                                    <th>Status</th>
                                </tr>
                            </thead>

                            <tbody>
                                {isLoading ? (
                                    <tr><td colSpan="4">Loading...</td></tr>
                                ) : tasks.length === 0 ? (
                                    <tr><td colSpan="4">No data found.</td></tr>
                                ) : (
                                    tasks.map((t, i) => (
                                        <tr key={t.id}>
                                            <td>{i + 1}</td>
                                            <td>{userTypeOptions.find(opt => opt.role == t.user_type)?.label || t.user_type}</td>

                                              <td>{`${t.guest_name ? t.guest_name + ' ' : ''}`} {`${t.guest_phone ? t.guest_phone + ' ' : ''}${t.guest_email ? t.guest_email + ' ' : ''}`}</td>
                                          <td>{t.task_date_time}</td>
                                            <td>{t.master_task_name}</td>
                                            <td>{t.task_detail}</td>
                                            <td>{t.status}</td>

                                          
                                        </tr>
                                    ))
                                )}
                            </tbody>

                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TasksDetailPrint;
